import React, { useState } from 'react';
import titleTemplate from 'lib/title-template';
import Head from 'next/head';
import Alert from 'components/common/alert';
import * as FeedbackModel from 'models/feedback-model';
import Page from 'components/common/page';
import Button from 'components/common/button';
import { NextPage } from 'next';
import { useSelector, shallowEqual } from 'react-redux';
import { Store } from 'redux/store';
import css from './contact.module.css';

const NAME = 'Contact Page';

const ContactPage: NextPage = () => {
  const [req, setReq] = useState<'waiting' | 'success' | 'error'>('waiting');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const updateName = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setName(event.target.value);
  };
  const updateEmail = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(event.target.value);
  };
  const updateMessage = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    setMessage(event.target.value);
  };
  const { data } = useSelector((state: Store) => state.auth, shallowEqual);
  const handleSubmit = async (
    event: React.FormEvent<HTMLFormElement>,
  ): Promise<void> => {
    event.preventDefault();
    try {
      await FeedbackModel.createFeedback({
        name: name,
        email: email,
        message: message,
        userAgent: navigator.userAgent,
        emailUsedAsLogin: data?.email,
      });
      setReq('success');
    } catch (error) {
      setReq('error');
    }
  };

  if (req === 'error') {
    return (
      <Page pageName={NAME}>
        <Alert type="danger">Your message was not sent due to an error.</Alert>
      </Page>
    );
  }

  if (req === 'success') {
    return (
      <Page pageName={NAME}>
        <Alert type="success">
          Thanks for contacting us! If you requested a response, we&apos;ll get
          back to you as soon as possible.
        </Alert>
      </Page>
    );
  }

  return (
    <Page pageName={NAME}>
      <Head>
        <title>{titleTemplate('Contact')}</title>
        <meta
          name="description"
          content="Send a message to our team to share feedback on Bibcitation features, report problems or just say hello!"
        />
      </Head>
      <div className={css.contact}>
        <h2 className={css.title}>Get in touch with us</h2>
        <p className={css.subtitle}>
          Fill out the following form to send us a message.
        </p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <label className={css.label}>
            Name
            <input
              type="text"
              placeholder="Name (optional)"
              className={css.input}
              onChange={updateName}
            />
          </label>
          <label className={css.label}>
            Email
            <input
              type="email"
              placeholder="Email (optional)"
              className={css.input}
              onChange={updateEmail}
            />
          </label>
          <label className={css.label}>
            Message
            <textarea
              placeholder="Message (required)"
              required
              className={css.textInput}
              onChange={updateMessage}
            />
          </label>
          <Button
            type="brand"
            size="medium"
            onClick={handleSubmit}
            style={{
              marginTop: 10,
            }}
          >
            Send Message
          </Button>
        </form>
      </div>
    </Page>
  );
};

export default ContactPage;
